/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nothing_Followed_YetInputs */

const th_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณยังไม่ได้ติดตามสิ่งใด`)
};

const en_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are not following anything yet.`)
};

const ja_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ何もフォローしていません。`)
};

const zh_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你还没有关注任何内容。`)
};

const es_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no sigues nada.`)
};

const pt_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você ainda não está seguindo nada.`)
};

const id_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda belum mengikuti apa pun.`)
};

const fr_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous ne suivez encore rien.`)
};

const tl_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala ka pang sinusundan.`)
};

const vi_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn chưa theo dõi gì cả.`)
};

const ko_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 아무것도 팔로우하지 않았습니다.`)
};

const de_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du folgst noch nichts.`)
};

const ru_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы пока ни на что не подписаны.`)
};

const tr_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz hiçbir şeyi takip etmiyorsunuz.`)
};

const it_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non segui ancora nulla.`)
};

const pl_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nic jeszcze nie obserwujesz.`)
};

const uk_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви поки ні за чим не стежите.`)
};

const hi_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप अभी कुछ भी फ़ॉलो नहीं करते।`)
};

const ar_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تتابع شيئًا بعد.`)
};

const ms_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda belum mengikuti apa-apa.`)
};

const bn_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি এখনও কিছু অনুসরণ করেন না।`)
};

const zh_tw2_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你尚未追蹤任何內容。`)
};

const zh_hk2_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你尚未追蹤任何內容。`)
};

const ur_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ ابھی کچھ فالو نہیں کرتے۔`)
};

const fa_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز چیزی را دنبال نمی‌کنید.`)
};

const sw_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hujafuatilia chochote bado.`)
};

const nl_nothing_followed_yet = /** @type {(inputs: Nothing_Followed_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je volgt nog niets.`)
};

/**
* | output |
* | --- |
* | "You are not following anything yet." |
*
* @param {Nothing_Followed_YetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nothing_followed_yet = /** @type {((inputs?: Nothing_Followed_YetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nothing_Followed_YetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nothing_followed_yet(inputs)
	if (locale === "ja") return ja_nothing_followed_yet(inputs)
	if (locale === "zh") return zh_nothing_followed_yet(inputs)
	if (locale === "es") return es_nothing_followed_yet(inputs)
	if (locale === "pt") return pt_nothing_followed_yet(inputs)
	if (locale === "id") return id_nothing_followed_yet(inputs)
	if (locale === "fr") return fr_nothing_followed_yet(inputs)
	if (locale === "tl") return tl_nothing_followed_yet(inputs)
	if (locale === "vi") return vi_nothing_followed_yet(inputs)
	if (locale === "ko") return ko_nothing_followed_yet(inputs)
	if (locale === "de") return de_nothing_followed_yet(inputs)
	if (locale === "ru") return ru_nothing_followed_yet(inputs)
	if (locale === "tr") return tr_nothing_followed_yet(inputs)
	if (locale === "it") return it_nothing_followed_yet(inputs)
	if (locale === "pl") return pl_nothing_followed_yet(inputs)
	if (locale === "uk") return uk_nothing_followed_yet(inputs)
	if (locale === "hi") return hi_nothing_followed_yet(inputs)
	if (locale === "ar") return ar_nothing_followed_yet(inputs)
	if (locale === "ms") return ms_nothing_followed_yet(inputs)
	if (locale === "bn") return bn_nothing_followed_yet(inputs)
	if (locale === "zh-TW") return zh_tw2_nothing_followed_yet(inputs)
	if (locale === "zh-HK") return zh_hk2_nothing_followed_yet(inputs)
	if (locale === "ur") return ur_nothing_followed_yet(inputs)
	if (locale === "fa") return fa_nothing_followed_yet(inputs)
	if (locale === "sw") return sw_nothing_followed_yet(inputs)
	if (locale === "nl") return nl_nothing_followed_yet(inputs)
	return en_nothing_followed_yet(inputs)
});